import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Layout() {
    const { user, logout, isAdmin } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="layout">
            {/* Sidebar */}
            <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                <div className="sidebar-header">
                    <h2>Kuberman CRM</h2>
                </div>

                <nav className="sidebar-nav">
                    <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="icon">📊</span>
                        <span>Dashboard</span>
                    </NavLink>

                    {isAdmin && (
                        <>
                            <NavLink to="/clients" className={({ isActive }) => isActive ? 'active' : ''}>
                                <span className="icon">👥</span>
                                <span>Clients</span>
                            </NavLink>

                            <NavLink to="/payments" className={({ isActive }) => isActive ? 'active' : ''}>
                                <span className="icon">💰</span>
                                <span>Payments</span>
                            </NavLink>
                        </>
                    )}

                    <NavLink to="/tasks" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="icon">✓</span>
                        <span>Tasks</span>
                    </NavLink>

                    {isAdmin && (
                        <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="icon">👤</span>
                            <span>Users</span>
                        </NavLink>
                    )}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <strong>{user?.full_name}</strong>
                        <small>{user?.role}</small>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <div className="main-content">
                <header className="top-bar">
                    <button 
                        className="sidebar-toggle"
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                    >
                        ☰
                    </button>

                    <div className="top-bar-right">
                        <span className="user-name">{user?.full_name}</span>
                        <button onClick={handleLogout} className="btn-logout">
                            Logout
                        </button>
                    </div>
                </header>

                <main className="page-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default Layout;
